import { cn } from 'utils/cn';

export const LockIcon: React.FC<{ size?: 'large' | 'medium' | 'small'; className?: string }> = ({ size = 'small', className }) => {
  if (size === 'large') {
    return (
      <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={cn('text-icn-txt-prim', className)}>
        <g clipPath="url(#clip0_2079_14200)">
          <rect x="2.20007" y="2" width="24" height="24" rx="12" className="fill-bg-prim-w-100" />
          <path
            d="M13.0001 10.25V12.5H15.4001V10.25C15.4001 9.58726 14.8628 9.05 14.2001 9.05C13.5373 9.05 13.0001 9.58726 13.0001 10.25Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2001 26C20.8275 26 26.2001 20.6274 26.2001 14C26.2001 7.37258 20.8275 2 14.2001 2C7.57266 2 2.20007 7.37258 2.20007 14C2.20007 20.6274 7.57266 26 14.2001 26ZM10.7501 12.5H11.2001V10.25C11.2001 8.59315 12.5432 7.25 14.2001 7.25C15.8569 7.25 17.2001 8.59315 17.2001 10.25V12.5H17.6501C18.6442 12.5 19.4501 13.3059 19.4501 14.3V18.1057C19.4501 19.0998 18.6442 19.9057 17.6501 19.9057H10.7501C9.75596 19.9057 8.95007 19.0998 8.95007 18.1057V14.3C8.95007 13.3059 9.75596 12.5 10.7501 12.5Z"
            fill="currentColor"
          />
        </g>
        <rect x="1.20007" y="1" width="26" height="26" rx="13" stroke="transparent" strokeWidth="2" />
        <defs>
          <clipPath id="clip0_2079_14200">
            <rect x="2.20007" y="2" width="24" height="24" rx="12" className="fill-bg-prim-w-100" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (size === 'medium') {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={cn('text-icn-txt-prim', className)}>
        <rect width="24" height="24" rx="12" className="fill-bg-prim-w-100" strokeWidth="1.66667" />
        <g clipPath="url(#clip0_1845_7863)">
          <rect x="4" y="4" width="16" height="16" rx="10" fill="transparent" />
          <path d="M11 8.875V10.75H13V8.875C13 8.32272 12.5523 7.875 12 7.875C11.4477 7.875 11 8.32272 11 8.875Z" fill="currentColor" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.125 10.75H9.5V8.875C9.5 7.49429 10.6193 6.375 12 6.375C13.3807 6.375 14.5 7.49429 14.5 8.875V10.75H14.875C15.7034 10.75 16.375 11.4216 16.375 12.25V15.4214C16.375 16.2498 15.7034 16.9214 14.875 16.9214H9.125C8.29657 16.9214 7.625 16.2498 7.625 15.4214V12.25C7.625 11.4216 8.29657 10.75 9.125 10.75Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_1845_7863">
            <rect x="2" y="2" width="20" height="20" rx="10" className="fill-bg-prim-w-100" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (size === 'small') {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={cn('text-icn-txt-prim', className)}>
        <path d="M7.2 5.5V7H8.8V5.5C8.8 5.05817 8.44183 4.7 8 4.7C7.55817 4.7 7.2 5.05817 7.2 5.5Z" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.7 7H6V5.5C6 4.39543 6.89543 3.5 8 3.5C9.10457 3.5 10 4.39543 10 5.5V7H10.3C10.9627 7 11.5 7.53726 11.5 8.2V10.7371C11.5 11.3999 10.9627 11.9371 10.3 11.9371H5.7C5.03726 11.9371 4.5 11.3999 4.5 10.7371V8.2C4.5 7.53726 5.03726 7 5.7 7Z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
